
import { Pie, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
 
export default {
  extends: Pie,
  mixins: [reactiveProp],
  
  data: () => ({
    gradient: null,
    options: {
          responsive: true, 
          maintainAspectRatio: false,
          legend: {
            position:"right",
            labels: {
                fontColor: "#19365A",
                fontSize: 11,
            }
       } 
    }
  }),
  mounted () {
     this.renderChart(this.chartData, this.options)
  }
}
